//USER ACTIONS
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_CUSTOM_DATA = "UPDATE_USER_CUSTOM_DATA";

//APP ACTIONS
export const TOGGLE_SIDEBAR = "app/toggle_sidebar";
export const TOGGLE_MOBILE = "app/toggle_mobile";
export const SET_VESTIGING = "app/set_vestiging";

//MESSAGE ACTIONS
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";

//RAPPORTAGE ACTIONS
export const HANDLE_DATE_CHANGE = "HANDLE_DATE_CHANGE";
export const HANDLE_MULTISELECT = "HANDLE_MULTISELECT";

//FILTERS
export const SET_FILTER = "filtersv2/set_filter";

//JAMEZZTABLE
export const SET_PER_PAGE = "SET_PER_PAGE";
export const SET_ORDERING = "SET_ORDERING";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_CURRENT_TABLE = "SET_CURRENT_TABLE";

//PERMISSION ACTIONS
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const SET_ALL_PERMISSIONS = "SET_ALL_PERMISSIONS";

//TRANSLATIONS
export const INIT_TRANSLATIONS = "INIT_TRANSLATIONS";
export const UPDATE_TRANSLATIONS = "UPDATE_TRANSLATIONS";
export const UPDATE_LANGUAGES_TO_TRANSLATE = "UPDATE_LANGUAGES_TO_TRANSLATE";
export const UPDATE_DISPLAYED_LANGUAGE = "UPDATE_DISPLAYED_LANGUAGE";
